import { Component, OnInit } from '@angular/core'
import { StoreService } from '@se-po/se-household-setup-data-access-store'

@Component({
  selector: 'se-po-docs-invite',
  templateUrl: './guardian-invite-docs.component.html',
  styleUrls: ['./guardian-invite-docs.component.scss'],
  standalone: false,
})
export class GuardianInviteDocsComponent implements OnInit {
  public storeLoaded = false
  public profile = {
    name: {
      first: 'John',
      last: 'Doe'
    },
    dateOfBirth: '2023-10-01',
    gender: 'male',
    gradYear: '2099'
  }

  constructor(public store: StoreService) { }

  ngOnInit(): void {
    this.store.childInfo = this.profile
    this.store.basePath = 'se-household-setup'
  }
}
